const ERROR_CODE = {
  NO_SOURCE: {
    code: '2404',
    msg: 'Prop `src` not found'
  },
  // Media Element
  2502: 'Media Network Error',
  2503: 'Video Cannot DECODE',
  2504: 'Video Cannot Play!',
  // JS runtime error
  2701: 'Parse Error',
  // not found reason
  2801: 'Not found reason'
}

export default ERROR_CODE
